import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import { useParams } from 'react-router-dom';
import { Card, Col, Form, Row } from 'react-bootstrap';
import CardHeader from '../../components/common/CardHeader';
import LinkButton from '../../components/common/LinkButton';
import {
      FormButton,
      FormImage,
      FormInput,
      FormStatusSelect,
      FormTextarea
} from '../../components/form';

const BannerEdit = () => {
      const { bannerId } = useParams();

      const [title, setTitle] = useState('');
      const [image, setImage] = useState('');
      const [imageUrl, setImageUrl] = useState('');
      const [subtitle, setSubtitle] = useState('');
      const [summary, setSummary] = useState('');
      const [sloganFirst, setSloganFirst] = useState('');
      const [sloganSecond, setSloganSecond] = useState('');
      const [buttonName, setButtonName] = useState('');
      const [buttonLink, setButtonLink] = useState('');
      const [status, setStatus] = useState('');
      const [loading, setLoading] = useState(false);

      const loadData = async () => {
            await axios
                  .get(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/banners/${bannerId}`,
                        {
                              headers: {
                                    Authorization: `Bearer ${JSON.parse(
                                          localStorage.getItem('token')
                                    )}`,
                                    'Content-Type': 'multipart/form-data'
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              setTitle(response.data.banner.title);
                              setSubtitle(response.data.banner.subtitle);
                              setSummary(response.data.banner.summary);
                              setSloganFirst(response.data.banner.slogan_first);
                              setSloganSecond(
                                    response.data.banner.slogan_second
                              );
                              setButtonName(response.data.banner.button_name);
                              setButtonLink(response.data.banner.link);
                              setImageUrl(response.data.banner.image);
                              setStatus(response.data.banner.status);
                        }
                  });
      };

      useEffect(() => {
            loadData();
      }, []);

      const handleFormSubmit = async (event) => {
            event.preventDefault();
            setLoading(true);
            const data = {
                  title: title,
                  status: status,
                  image: image,
                  subtitle: subtitle,
                  slogan_first: sloganFirst,
                  slogan_second: sloganSecond,
                  summary: summary,
                  banner_link: buttonLink,
                  button_name: buttonName
            };

            await axios
                  .post(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/banners/${bannerId}`,
                        data,
                        {
                              headers: {
                                    Authorization: `Bearer ${JSON.parse(
                                          localStorage.getItem('token')
                                    )}`,
                                    'Content-Type': 'multipart/form-data'
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              toast.success(response.data.message);
                        }
                        if (response.data.result === 'error') {
                              if (response.data.message.title) {
                                    toast.error(response.data.message.title);
                              }
                              if (response.data.message.subtitle) {
                                    toast.error(response.data.message.subtitle);
                              }
                              if (response.data.message.summary) {
                                    toast.error(response.data.message.summary);
                              }
                              if (response.data.message.slogan_first) {
                                    toast.error(
                                          response.data.message.slogan_first
                                    );
                              }
                              if (response.data.message.slogan_second) {
                                    toast.error(
                                          response.data.message.slogan_second
                                    );
                              }
                              if (response.data.message.button_link) {
                                    toast.error(
                                          response.data.message.button_link
                                    );
                              }
                              if (response.data.message.button_name) {
                                    toast.error(
                                          response.data.message.button_name
                                    );
                              }
                              if (response.data.message.image) {
                                    toast.error(response.data.message.image);
                              }
                              if (response.data.message.status) {
                                    toast.error(response.data.message.status);
                              }
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };

      return (
            <>
                  <Form onSubmit={handleFormSubmit}>
                        <Row>
                              <Col lg={12}>
                                    <Card>
                                          <CardHeader title="Edit Banner">
                                                <LinkButton
                                                      link="/dashboard/banners"
                                                      title="Back"
                                                />
                                          </CardHeader>
                                          <Card.Body>
                                                <Row className="g-3">
                                                      <FormInput
                                                            title="Title"
                                                            value={title}
                                                            required={true}
                                                            classes={8}
                                                            handleChange={
                                                                  setTitle
                                                            }
                                                      />
                                                      <FormStatusSelect
                                                            title="Status"
                                                            selected={status}
                                                            classes={4}
                                                            setStatus={
                                                                  setStatus
                                                            }
                                                      />
                                                      <FormInput
                                                            title="Sub Title"
                                                            required={false}
                                                            classes={4}
                                                            value={subtitle}
                                                            handleChange={
                                                                  setSubtitle
                                                            }
                                                      />
                                                      <FormInput
                                                            title="Slogan First"
                                                            required={false}
                                                            classes={4}
                                                            value={sloganFirst}
                                                            handleChange={
                                                                  setSloganFirst
                                                            }
                                                      />
                                                      <FormInput
                                                            title="Slogan Second"
                                                            required={false}
                                                            value={sloganSecond}
                                                            classes={4}
                                                            handleChange={
                                                                  setSloganSecond
                                                            }
                                                      />
                                                      <FormInput
                                                            title="Button Name"
                                                            required={false}
                                                            classes={4}
                                                            value={buttonName}
                                                            handleChange={
                                                                  setButtonName
                                                            }
                                                      />
                                                      <FormInput
                                                            title="Banner Link"
                                                            required={false}
                                                            value={buttonLink}
                                                            classes={4}
                                                            handleChange={
                                                                  setButtonLink
                                                            }
                                                      />
                                                      <FormTextarea
                                                            title="Summary"
                                                            value={summary}
                                                            handleChange={
                                                                  setSummary
                                                            }
                                                      />
                                                </Row>
                                          </Card.Body>
                                    </Card>

                                    <Card className="mt-4">
                                          <Card.Body>
                                                <Row>
                                                      <FormImage
                                                            title="Featured Image"
                                                            setImage={setImage}
                                                            setImageUrl={
                                                                  setImageUrl
                                                            }
                                                            required={true}
                                                            imageUrl={imageUrl}
                                                      />
                                                </Row>
                                          </Card.Body>
                                    </Card>

                                    <Card className="mt-4 mb-5">
                                          <Card.Body>
                                                <Col lg={12}>
                                                      <FormButton
                                                            title="Submit"
                                                            loading={loading}
                                                      />
                                                </Col>
                                          </Card.Body>
                                    </Card>
                              </Col>
                        </Row>
                  </Form>
            </>
      );
};

export default BannerEdit;
